import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

export const FarmRoutes = {
    Farm: "/farm",
} as const;

export const farmRoutes = (
    <Route
        path={FarmRoutes.Farm}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { FarmModuleLayout } =
                await import("@farm/presentation/layout/farm-module.layout");
            return { Component: FarmModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { FarmWebPage } =
                    await import("@farm/presentation/pages/farm/farm-web.page.tsx");
                return { Component: FarmWebPage };
            }}
        />
    </Route>
);
